module.exports = __webpack_public_path__ + "img/404.7ece3b01e71c2a47cdf2e2fb5e1fc2d7.gif";